import { QueryClient } from "@tanstack/react-query";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { get, set, del } from "idb-keyval";

// K2 (ARCHITECTURE §5): cache IndexedDB + stale-while-revalidate.
// P3: dữ liệu màn lớp (api/duLieuLop.ts) persist ở đây — có cache thì vẽ ngay rồi gọi rpc_delta nền.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 1000 * 60 * 60 * 24, // giữ cache 24h trong IndexedDB
      retry: 1,
    },
  },
});

export const idbPersister = createAsyncStoragePersister({
  storage: {
    getItem: (key: string) => get(key),
    setItem: (key: string, value: string) => set(key, value),
    removeItem: (key: string) => del(key),
  },
  key: "web-van-hanh-cache",
});

/**
 * Lối thoát khi web vỡ màn vì cache cũ sai dạng (sự cố 05/11/2026: cache `cau_suc_khoe` cũ làm trắng cả web): xoá cache trong RAM +
 * IndexedDB rồi tải lại trang ⇒ lần mở sau tải cả bộ mới từ máy chủ. Không đụng phiên đăng nhập (nằm ở localStorage của Supabase).
 */
export async function xoaCacheVaTaiLai(): Promise<void> {
  try {
    queryClient.clear();
    await idbPersister.removeClient();
  } catch { /* trình duyệt chặn IndexedDB ⇒ vẫn tải lại */ }
  window.location.reload();
}
